import React, { useContext, useEffect, useState } from "react";
import "./MobileMenu.css";
import Colors from "../../Helper/Colors";
import { useNavigate, useLocation } from "react-router-dom";
import { techappContext } from "../../Api/techappReq";
import FormatHelper from "../../Helper/FormatHelper";
// import images
import ordersImage from "../../assets/images/techapp/orders-black.svg";
import commnetImage from "../../assets/images/techapp/comment-black.svg";
import userImage from "../../assets/images/techapp/user-black.svg";
import { TfiStatsUp } from "react-icons/tfi";
import { FaStar } from "react-icons/fa";

const MobileMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuKey, setMenuKey] = useState(0);

  const { getBadges } = useContext(techappContext);

  useEffect(() => {
    switch (location.pathname) {
      case "/techapp":
        setMenuKey(0);
        break;
      case "/techapp/view-order":
        setMenuKey(0);
        break;
      case "/techapp/define-cost":
        setMenuKey(0);
        break;
      case "/techapp/search":
        setMenuKey(0);
        break;
      case "/techapp/stats":
        setMenuKey(1);
        break;
      case "/techapp/tickets":
        setMenuKey(2);
        break;
      case "/techapp/view-ticket":
        setMenuKey(2);
        break;
      case "/techapp/create-ticket":
        setMenuKey(2);
        break;
      case "/techapp/profile":
        setMenuKey(3);
        break;
      case "/techapp/survey":
        setMenuKey(4);
        break;
      default:
        break;
    }
  }, [location.pathname]);

  return (
    <div style={{ color: Colors.royalBlue }} className="tech-app-mobile-menu">
      <div
        onClick={() => {
          navigate("/techapp");
        }}
        className={menuKey === 0 ? "tech-app-mobile-menu-active" : ""}
      >
        <img src={ordersImage} alt="orders" />
        <small>سفارشات</small>
      </div>
      <div
        onClick={() => {
          navigate("/techapp/survey");
        }}
        className={menuKey === 4 ? "tech-app-mobile-menu-active" : ""}
      >
        <FaStar fontSize={24} color="#1e5279" />
        <small>امتیازات</small>
      </div>
      <div
        onClick={() => {
          navigate("/techapp/tickets");
        }}
        className={menuKey === 2 ? "tech-app-mobile-menu-active" : ""}
      >
        <img src={commnetImage} alt="messages" />
        <small style={{ position: "relative" }}>
          گفتگو
          {getBadges && (
            <small className="techapp-mobile-menu-unread-message-count">
              {FormatHelper.toPersianString(
                getBadges.training +
                  getBadges.public +
                  getBadges.private +
                  getBadges.ticket
              )}
            </small>
          )}
        </small>
      </div>
      <div
        onClick={() => {
          navigate("/techapp/stats");
        }}
        className={menuKey === 1 ? "tech-app-mobile-menu-active" : ""}
      >
        <TfiStatsUp style={{ paddingTop: 3, fontSize: 24 }} />
        <small>عملکرد من</small>
      </div>

      <div
        onClick={() => {
          navigate("/techapp/profile");
        }}
        className={menuKey === 3 ? "tech-app-mobile-menu-active" : ""}
      >
        <img src={userImage} alt="profile" />
        <small>پروفایل</small>
      </div>
    </div>
  );
};
export default MobileMenu;
